class TestSound {
  private audioContext: AudioContext | null = null;
  private audioElement: HTMLAudioElement | null = null;

  constructor(sinkId: string | null, maxGainValue = 0.05) {
    try {
      this.audioContext = new (window.AudioContext ||
        (window as any).webkitAudioContext)();
      if (!this.audioContext) {
        throw new Error("Failed to create AudioContext");
      }

      const audioCtx = this.audioContext;
      const destination = audioCtx.createMediaStreamDestination();
      const masterGain = audioCtx.createGain();
      masterGain.connect(destination);

      const now = audioCtx.currentTime;

      // Unified sound array: sine beeps first, then triangle boops
      const soundSequence = [
        { type: "sine", offset: 0.0, freq: 660, duration: 0.2 },
        { type: "sine", offset: 0.4, freq: 880, duration: 0.15 },
        { type: "sine", offset: 0.75, freq: 550, duration: 0.3 },
        { type: "triangle", offset: 1.3, freq: 330, duration: 0.2 },
        { type: "triangle", offset: 1.7, freq: 440, duration: 0.15 },
        { type: "triangle", offset: 2.4, freq: 220, duration: 0.4 },
      ] as const;

      let lastEnd = 0;

      soundSequence.forEach(({ type, offset, freq, duration }) => {
        const start = now + offset;

        const osc = audioCtx.createOscillator();
        osc.type = type;
        osc.frequency.value = freq;

        const gain = audioCtx.createGain();
        gain.gain.setValueAtTime(0, start);
        gain.gain.linearRampToValueAtTime(maxGainValue, start + 0.01);
        gain.gain.linearRampToValueAtTime(0, start + duration);

        osc.connect(gain).connect(masterGain);
        osc.start(start);
        osc.stop(start + duration + 0.05);

        lastEnd = Math.max(lastEnd, offset + duration);
      });

      // Set up playback via AudioElement
      this.audioElement = new Audio();
      this.audioElement.srcObject = destination.stream;

      const playAudio = () => {
        this.audioElement!.play();
      };

      if (sinkId && "setSinkId" in HTMLAudioElement.prototype) {
        this.audioElement.setSinkId(sinkId).then(playAudio);
        // .catch((err) => console.error("Error setting sink ID:", err));
      } else {
        playAudio();
      }

      // Cleanup after last sound ends
      const buffer = 0.5;
      setTimeout(() => this.cleanup(), (lastEnd + buffer) * 1000);
    } catch (err) {
      this.cleanup();
    }
  }

  private cleanup() {
    if (this.audioElement) {
      this.audioElement.pause();
      this.audioElement.srcObject = null;
      this.audioElement = null;
    }
    if (this.audioContext) {
      this.audioContext.close();
      this.audioContext = null;
    }
  }
}

export default TestSound;
